module.exports = ".menu-colaps{\r\n    height: calc(100vh - 60px);\r\n    overflow: auto;\r\n    overflow-x: hidden;    \r\n    top: 60px;\r\n}\t\t"